import { Controller } from 'stimulus';

// The server renders the value, so this only steps in once something moves the bar.
export default class extends Controller {
  // For another controller to route its own event here, carrying { value }.
  update(event) {
    this.element.value = event.detail.value;
  }
}
